import { useState } from "react";
import { useParams } from "react-router";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

const useChangePassword = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const auth = JSON.parse(queryParams.get("auth"));
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const validatePassword = (value) => {
    if (value.length < 8) return "Password must be at least 8 characters long.";

    return "";
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setPasswordError(validatePassword(value));
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    setConfirmPasswordError(
      value !== password ? "Passwords do not match." : ""
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const passwordValidationError = validatePassword(password);
    setPasswordError(passwordValidationError);

    setConfirmPasswordError(
      confirmPassword !== password ? "Passwords do not match." : ""
    );

    if (passwordValidationError || confirmPassword !== password) {
      return;
    } else {
      changePassword();
    }
  };

  const changePassword = async () => {
    try {
      setSubmitLoader(true);
      const response = await apiHandler({
        url: endpoint.CHANGE_PASSWORD,
        method: "POST",
        authToken: auth,
        dispatch,
        data: {
          newPassword: confirmPassword,
        },
      });
      if (response.data.success) {
        setIsSuccess(true);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      
    } finally {
      setSubmitLoader(false);
    }
  };

  return {
    password,
    confirmPassword,
    passwordError,
    confirmPasswordError,
    showPassword,
    setShowConfirmPassword,
    setShowPassword,
    showConfirmPassword,
    handlePasswordChange,
    handleConfirmPasswordChange,
    handleSubmit,
    submitLoader,
    isSuccess,
    auth,
  };
};

export default useChangePassword;
